export default __webpack_public_path__ + "static/media/basketball.9f2d9785.png";